/* eslint-disable import/prefer-default-export */
export const ca = {
  translation: {
    title: 'Validar còpia autoritzada electrònica',
    desc:'Introdueix el CSV (Codi Segur de Verificació) i prem el botó Validar per comprovar l’autenticitat i la integritat de la còpia autoritzada electrònica del document notarial, així com per conèixer les notes posteriors de modificació jurídica i de coordinació amb altres instruments públics.',
    placeholderCSV:'Codi CSV',
    validateButton: 'Validar',
    backButton:'Tornar',
    okButton:'Acceptar',
    cancelButton:'Cancel·lar',
    closeButton:'Tancar',
    actionsButton:'Accions',
    downloadButton:'Descarregar',
    head:{
      title: 'SEU ELECTRÒNICA NOTARIAL',
    },
    footer:{
      legalNotice: 'Avís Legal',
      privacyPolicy: 'Política de privacitat',
      accessibility: 'Accessibilitat',
      cookiesPolicy: 'Política de cookies',
      supportedBrowsers: 'Navegadors compatibles',
    },
    modalsupportedbrowsers:{
      other: 'Podeu accedir utilitzant un PC, Mac, mòbil o tauleta.',
    },
    actions: {
      helpButton:'Veure ajuda',
      validateSignature:'Validar signatura',
      download:'Descarregar',
      downloadCombined: 'Descarregar units'
    },
    modalAyuda:{
      title:'Ajuda',
      guide:'Aquí pots descarregar la guia relacionada amb aquesta secció',
      section1: 'Comprovar la validesa de la signatura mitjançant la Seu Electrònica Notarial',
      desc1: 'Per comprovar la validesa de la signatura electrònica qualificada del notari en el document notarial, fes clic al botó <strong>Accions</strong> i selecciona <strong>Validar signatura</strong>.',
      section2: 'Comprovar la validesa de la signatura mitjançant Adobe Acrobat Reader',
      desc2: 'Per comprovar la validesa de la signatura electrònica qualificada del notari en el document notarial, fes clic al botó <strong>Accions</strong> i selecciona <strong>Descarregar</strong>. Després, obre el document amb Adobe Acrobat Reader i fes clic a la icona de la ploma situada al menú lateral. <br /><br /> A la llista desplegable podràs comprovar la validesa de la signatura i analitzar-ne els detalls.',
      section3: 'Comprovar la validesa de la signatura mitjançant VALIDe',
      desc3: 'Per comprovar la validesa de la signatura electrònica qualificada del notari en el document notarial, fes clic al botó <strong>Accions</strong> i selecciona <strong>Descarregar</strong>. Després, utilitza la',
      linkText: 'plataforma pública VALIDe',
    },
    modalCopia:{
      title:'Còpia autoritzada electrònica',
    },
    modalErrorServicio:{
      desc: 'No existeix cap còpia autoritzada electrònica vinculada al codi CSV que has introduït. Revisa el codi i torna-ho a provar.',
      contactSupport: 'Si continues tenint problemes, pots posar-te en contacte amb el servei de suport.',
    },
    modalAdvertenciaDescarga:{
      title:'Advertència',
      desc:'<strong>Les notes</strong> de modificació jurídica i de coordinació amb altres instruments públics <strong>emeses després de l’expedició de la còpia no estaran disponibles en el document que descarregaràs.</strong> Només figuren en el justificant d’expedició de la còpia.',
    },
    modalErrorGenerico:{
      desc:'S’ha produït un problema. Torna-ho a provar.',
    },
    modalErrorValidacion:{
      title:'Error en la validació de la signatura.',
      desc:'No s’ha pogut validar la signatura del document. Torna-ho a provar o posa’t en contacte amb el servei de suport.',
    },
    modalManuales:{
      name:'Nom',
    },
    modalValidacionFirma:{
      title:'Validar signatura',
      firmaNotario:'SIGNATURA QUALIFICADA DEL NOTARI:',
      fechaFirma:'DATA DE LA SIGNATURA:',
      fechaValidacion:'DATA DE LA VALIDACIÓ:',
      estadoFirma:'ESTAT DE LA SIGNATURA:',
      validacionFirma:'Validació de la signatura electrònica del Consell General del Notariat',
      validada:'Validada',
      noValidada:'No validada',
      contenido:'Contingut del document',
      alterado:'alterat',
      noAlterado:'no alterat',
      certificadoFirmante:'Certificat del signant',
      caducado:'caducat',
      noCaducado:'no caducat',
      revocado:'revocat',
      noRevocado:'no revocat',
      certificadoCa:'emès per una autoritat de certificació de confiança (CA)',
      noCertificadoCa:'no emès per una CA de confiança',
    },
  },
};
